module.exports = __webpack_public_path__ + "img/ckja1.e485ba66.jpeg";